import { useState, useEffect } from "react";
import { CreditsAppliedResultEntity } from "../../domain/entities/CreditNoteEntity";
import { GetCreditsAppliedUseCase } from "../../domain/use-cases/GetCreditsAppliedUseCase";
import { CreditNoteRepositoryImpl } from "../../data/repositories/CreditNoteRepositoryImpl";

const repository = new CreditNoteRepositoryImpl();
const getCreditsAppliedUseCase = new GetCreditsAppliedUseCase(repository);

export const useCreditsApplied = (creditNoteId: number | null) => {
  const [creditsApplied, setCreditsApplied] =
    useState<CreditsAppliedResultEntity | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!creditNoteId) {
      setCreditsApplied(null);
      return;
    }

    const fetchCreditsApplied = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await getCreditsAppliedUseCase.execute(creditNoteId);
        setCreditsApplied(result);
      } catch (err: any) {
        setError(err.message || "Failed to fetch credits applied");
      } finally {
        setLoading(false);
      }
    };

    fetchCreditsApplied();
  }, [creditNoteId]);

  return { creditsApplied, loading, error };
};
